import { FC } from 'react';

const PaleoIcon: FC<{
  fill?: string;
  height?: number;
  width?: number;
}> = ({ fill = '#3C3F43', height = 16, width = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_42381_16255)">
        <path
          d="M7.75303 10.553L5.4597 8.25967C4.23303 7.033 9.9997 -3.55367 14.7664 1.233C19.533 6.01967 8.8197 11.6263 7.75303 10.553Z"
          fill={fill}
        />
        <path
          d="M4.78658 13.3327C4.66598 13.2138 4.52905 13.1128 4.37992 13.0327L6.08658 11.3327C6.14766 11.2704 6.18187 11.1866 6.18187 11.0993C6.18187 11.0121 6.14766 10.9283 6.08658 10.866L5.13992 9.91267C5.07761 9.85159 4.99383 9.81738 4.90658 9.81738C4.81933 9.81738 4.73556 9.85159 4.67325 9.91267L2.96658 11.6193C2.88643 11.4702 2.78541 11.3333 2.66658 11.2127C2.52989 11.0538 2.36247 10.9242 2.17439 10.8318C1.98631 10.7393 1.78147 10.6859 1.57219 10.6747C1.36291 10.6634 1.15353 10.6947 0.95665 10.7665C0.759769 10.8384 0.579462 10.9493 0.426583 11.0927C0.283227 11.2455 0.172291 11.4259 0.100453 11.6227C0.0286149 11.8196 -0.00263938 12.029 0.00857192 12.2383C0.0197832 12.4476 0.0732282 12.6524 0.165689 12.8405C0.25815 13.0286 0.387715 13.196 0.546583 13.3327C0.715273 13.4979 0.915604 13.6274 1.13556 13.7133C1.35551 13.7992 1.59055 13.8398 1.82658 13.8327C1.87123 13.8327 1.91544 13.8415 1.9567 13.8585C1.99795 13.8756 2.03543 13.9007 2.067 13.9323C2.09857 13.9638 2.12362 14.0013 2.1407 14.0426C2.15779 14.0838 2.16658 14.128 2.16658 14.1727C2.15944 14.4087 2.20004 14.6437 2.28596 14.8637C2.37188 15.0836 2.50134 15.284 2.66658 15.4527C2.80327 15.6115 2.9707 15.7411 3.15877 15.8336C3.34685 15.926 3.5517 15.9795 3.76098 15.9907C3.97025 16.0019 4.17963 15.9706 4.37652 15.8988C4.5734 15.827 4.7537 15.716 4.90658 15.5727C5.04994 15.4198 5.16087 15.2395 5.23271 15.0426C5.30455 14.8457 5.3358 14.6363 5.32459 14.4271C5.31338 14.2178 5.25994 14.0129 5.16748 13.8249C5.07502 13.6368 4.94545 13.4694 4.78658 13.3327Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_42381_16255">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PaleoIcon;
